import axios from "axios";
import store from "../store/index";
import { getExceptionMessage, API_BASE_URL    , listProps } from "../utils/helper";
import { processResponse } from "./serviceUtil";
import billerCrossReferenceActionTypes from "../actions/types/billerCrossReference.action.type";

export const billerCrossReferenceService = {
    searchBillerCrossReference
};

function searchBillerCrossReference(bcrData, props) {
    return (dispatch) => {
        const user = store.getState()?.loginUserReducer.user;
        const token = store.getState()?.loginUserReducer.token;

        const request = {   userId: user.userId,
            languageCode: user.languageCode,
            ...bcrData
        };

        axios
            .post(
                `${API_BASE_URL()}/searchBillerCrossReference`,
                request,
                { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, } }
            )
            .then((res) => {
                const response = {
                    data: res.data,
                    bcrDetails: { ...bcrData },
                };
                dispatch( {data: response,  type: billerCrossReferenceActionTypes.GET_BILLER_CROSS_REFERENCE_SUCCESS} );
                processResponse(true, props);
            })
            .catch((error) => {
                let errorMessage = getExceptionMessage(error);
                dispatch( {error: errorMessage,  type: billerCrossReferenceActionTypes.GET_BILLER_CROSS_REFERENCE_ERROR} );
                processResponse(false, props, errorMessage);
            });
    };
}